import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import {
  CostCenterListState,
  CostCenterListStore,
} from './cost-center-list.store';
import {ISavedListSettingsQuery} from '../../interfaces/settings/saved-list-settings.query';
import {TableColumn} from '../../models/table-column';
import {getCostCenterFilterOptions, getTableColumns} from './cost-center-table-columns';
import {state} from '@angular/animations';

@Injectable({
  providedIn: 'root',
})
export class CostCenterListQuery extends Query<CostCenterListState> implements ISavedListSettingsQuery {
  columns$;
  filterOptions$;
  filterValue$;

  constructor(protected store: CostCenterListStore) {
    super(store);

    this.columns$ = this.select((state) => state.columns);
    this.filterOptions$ = this.select((state) => state.filterOptions);
    this.filterValue$ = this.select((state) => state.filterValue);
  }

  filterOptions(): any {
    return this.store.getValue()?.filterOptions;
  }

  getFilterColumns(): TableColumn[] {
    return null;
  }

  getInitialColumns(): TableColumn[] {
    return getTableColumns();
  }

  getTableColumns(): TableColumn[] {
    return this.store.getValue()?.columns;
  }

  newFilterStructure(): boolean {
    return false;
  }

  getInitialFilter(): any {
    return getCostCenterFilterOptions();
  }

  hasFilter(): boolean {
    return true;
  }
}
